
import RegionsCarbonTable, { convertRegionResultsToViewItems } from '@/components/Domain.Regions/RegionsCarbonTable.vue';
export { convertRegionResultsToViewItems };
import { defineComponent } from 'vue';
export default defineComponent({
    components: { RegionsCarbonTable },
    props: { ...RegionsCarbonTable.props, title: String },
});
